import { Component, Input, OnInit } from '@angular/core';
import { InterfacesService } from '../interfaces.service';
import { NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl } from '@angular/forms';
import { ClienteService } from '@cliente/cliente.service';
import { TipoInterfaces } from '@shared/enums/TipoInterfaces';
import { UsuarioService } from '@account/usuario.service';
import { MessageService } from '@shell/message.service';
import { ErrorModel } from '@shared/models/ErrorModel';

@Component({
  selector: 'app-interfaces-detalle',
  templateUrl: './interfaces-detalle.component.html',
  styleUrls: ['./interfaces-detalle.component.scss']
})
export class InterfacesDetalleComponent implements OnInit {

  @Input() interfaz;
  TipoInterfaces = TipoInterfaces
  asientos = [];
  asientosAMostrar = [];
  clienteCENIT;
  model: NgbDateStruct;
  cargandoAsientos: boolean;
  cargandoCliente: boolean;
  buscadorAsientosFormControl = new UntypedFormControl();
  buscadorCENITFormControl = new UntypedFormControl();
  @Input() error: boolean;
  @Input() mensajeError: string;
  errorAsientos: boolean;
  errorCENIT: boolean;
  mostrarAsientosRechazados: boolean = true;

  constructor(private interfacesService: InterfacesService, private calendar: NgbCalendar, 
    private clientesService: ClienteService, private usuarioService: UsuarioService, private messageService: MessageService) {}

  ngOnInit() {
    this.model = this.calendar.getToday();
  }

  cargarAsientos() {
    this.cargandoAsientos = true;
    //formatea la fecha para enviar 07 y no 7
    const dia = this.model.day.toString().length == 1 ? "0" + this.model.day : this.model.day;
    const mes = this.model.month.toString().length == 1 ? "0" + this.model.month : this.model.month;
    const fecha = this.model.year.toString() + mes + dia;
    this.interfacesService.obtenerMonitorAsientosContables(fecha).then(asientos => {
      this.asientos = asientos.sort((a, b) => {
        const fechaA = new Date(`${a.FechaCreacion}T${a.HoraCreacion}`).getTime();
        const fechaB = new Date(`${b.FechaCreacion}T${b.HoraCreacion}`).getTime();
        return fechaB - fechaA; // Restamos los valores en milisegundos
    });
      this.asientosAMostrar = this.asientos;
      this.chequearListaAsientosRechazados();
      this.cargandoAsientos = false;
    }).catch(() => {
      this.cargandoAsientos = false;
      this.errorAsientos = true;
      this.mensajeError = 'No se pudo conectar con la interfaz de asientos';
    });
  }

  filtrarAsientosPorNroSAP() {
    this.asientosAMostrar = this.asientos.filter(a => a.STAPA1.toString().includes(this.buscadorAsientos.value))
  }

  validarFormatoCuit(): boolean {
    const regexCuit = /^(20|23|24|27|30|33|34)([0-9]{9}|[0-9]{8}[0-9]{1})$/g;
    const p = regexCuit.test(this.buscadorCenit.value)
    return p;
  }

  obtenerClienteCENIT() {
    this.cargandoCliente = true;
    this.clientesService.validarClienteCenit(this.usuarioService.getAeroplantaActual().codigoAeroplanta, this.buscadorCenit.value, true, false).subscribe( cliente => {
      this.clienteCENIT = cliente;
      this.cargandoCliente = false;
    }, (err: ErrorModel) => {
      this.errorCENIT = true;
      this.mensajeError = err.description;
      this.cargandoCliente = false;
    })    
  }

  chequearListaAsientosRechazados() {
    if(this.mostrarAsientosRechazados) {
      this.asientosAMostrar = this.asientosAMostrar.filter(a => a.Status == '51');
    } else this.asientosAMostrar = this.asientos;
  }

  chequearInterfazAsientos(i) {
    if(i.nombre == TipoInterfaces.ASIENTOS ) { return true }  else return false;
  }
  chequearInterfazCENIT(i) {
    if(i.nombre == TipoInterfaces.CENIT ) { return true }  else return false;
  }

  get buscadorAsientos() {
    return this.buscadorAsientosFormControl;
  }

  get buscadorCenit() {
    return this.buscadorCENITFormControl;
  }
}
